import { FormEvent, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'shared-ui/lib/components/Button';
import { InviteCustomerFormBody } from './invite-customer.form';

type Props = {
  loading: boolean;
  onSubmit: (body: InviteCustomerFormBody) => Promise<void>;
};

const inputClassName =
  'appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-primary focus:border-primary sm:text-sm';

export const InviteCustomerForm = ({ loading, onSubmit }: Props): JSX.Element => {
  const { t } = useTranslation('ServiceCallCustomersScene');
  const [email, setEmail] = useState('');

  const handleSubmit = async (event: FormEvent) => {
    event.preventDefault();
    const trimmed = email.trim();
    if (!trimmed) return;
    await onSubmit({ email: trimmed });
    setEmail('');
  };

  return (
    <form className="mb-4" onSubmit={handleSubmit}>
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4 items-end">
        <div className="lg:col-span-2">
          <label htmlFor="invite-customer-email" className="block text-sm font-medium text-gray-700 mb-1">
            {t('inviteEmail')}
          </label>
          <input
            id="invite-customer-email"
            type="email"
            required
            autoComplete="email"
            className={inputClassName}
            value={email}
            onChange={(event) => setEmail(event.target.value)}
          />
        </div>
        <div>
          <Button type="submit" loading={loading}>
            {t('inviteSubmit')}
          </Button>
        </div>
      </div>
    </form>
  );
};
